export const SITE_URL = "https://lapopote.co";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Batch Cooking",
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.svg`,
  description:
    "Application web et mobile de planification de batch cooking hebdomadaire pilotée par l'IA, pour les foyers français.",
  foundingDate: "2026",
  foundingLocation: { "@type": "Place", name: "Paris, France" },
  areaServed: { "@type": "Country", name: "France" },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    email: "contact@lapopote.co",
    availableLanguage: "French",
  },
};

export const softwareAppSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Batch Cooking",
  applicationCategory: "LifestyleApplication",
  operatingSystem: "iOS, Android, Web",
  url: SITE_URL,
  description:
    "Planificateur de batch cooking hebdomadaire piloté par l'IA. Génère un menu de 7 dîners personnalisé, une liste de courses optimisée et un plan de cuisson pas-à-pas.",
  inLanguage: "fr",
  offers: [
    {
      "@type": "Offer",
      name: "L'Essentiel",
      price: "0",
      priceCurrency: "EUR",
      description:
        "Menu hebdomadaire pré-composé, liste de courses, mode cuisine. Gratuit à vie.",
    },
    {
      "@type": "Offer",
      name: "Le Cahier",
      price: "7.90",
      priceCurrency: "EUR",
      priceSpecification: {
        "@type": "UnitPriceSpecification",
        price: "7.90",
        priceCurrency: "EUR",
        billingDuration: "P1M",
      },
      description:
        "Menus IA entièrement personnalisés, substitutions illimitées, thèmes hebdomadaires, partage foyer.",
    },
  ],
  featureList: [
    "Génération de menus par IA",
    "Liste de courses triée par rayon",
    "Mode cuisine pas-à-pas",
    "Gestion des allergies et régimes",
    "Partage de menu en famille",
    "Mode hors-ligne (premium)",
  ],
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Qu'est-ce que le batch cooking ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Le batch cooking est une méthode de cuisine consistant à préparer plusieurs repas en une seule session hebdomadaire — généralement le dimanche — pour gagner du temps en semaine.",
      },
    },
    {
      "@type": "Question",
      name: "Comment Batch Cooking génère-t-il mon menu ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Notre IA analyse vos préférences (régime, allergies, équipement disponible, temps) et compose 7 dîners équilibrés partageant un maximum d'ingrédients de base, pour limiter le gaspillage et les achats.",
      },
    },
    {
      "@type": "Question",
      name: "Est-ce que Batch Cooking est gratuit ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Oui, la formule L'Essentiel est gratuite à vie. La formule Le Cahier à 7,90 €/mois ou 69 €/an débloque les menus IA entièrement personnalisés et les substitutions illimitées.",
      },
    },
    {
      "@type": "Question",
      name: "Puis-je indiquer mes allergies ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Oui, vous déclarez vos allergies et intolérances lors de l'onboarding. L'IA en tient compte lors de la génération du menu, mais nous recommandons de toujours vérifier chaque recette.",
      },
    },
    {
      "@type": "Question",
      name: "Batch Cooking est-il disponible sur mobile ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Oui, Batch Cooking est disponible sur iPhone (App Store), Android (Google Play) et directement dans le navigateur web.",
      },
    },
    {
      "@type": "Question",
      name: "L'application fonctionne-t-elle hors ligne ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "En mode premium (Le Cahier), les menus générés peuvent être consultés hors ligne. La génération de nouveaux menus nécessite une connexion internet.",
      },
    },
    {
      "@type": "Question",
      name: "Puis-je partager mon menu avec ma famille ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Oui, la formule Le Cahier inclut le partage foyer jusqu'à 4 membres. Vous pouvez aussi partager un lien de lecture seule de n'importe quel menu.",
      },
    },
    {
      "@type": "Question",
      name: "Comment annuler mon abonnement ?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Vous pouvez annuler à tout moment depuis les réglages de l'application (iOS : App Store → votre compte → Abonnements ; Android : Play Store → Abonnements). Il n'y a aucun engagement de durée.",
      },
    },
  ],
};

export function breadcrumbSchema(items: Array<{ name: string; path: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}
